import { __assign, __rest } from "tslib";
import React from 'react';
import { TableBody as MUTableBody } from '@material-ui/core';
export var TableBody = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(MUTableBody, __assign({}, props), children);
};
//# sourceMappingURL=TableBody.js.map